import { useAuthAPI } from '@whitecobalt/tungsten/esm/common/hooks/useAuthAPI'
import React, { createContext, useContext, useLayoutEffect } from 'react'

export type StoreNavigationType = {
    isNavMenu: boolean;
    listOrder: number;
    title: string;
    url: string;
    items: StoreNavigationType[]
}

const StoreNavigationContext = createContext<{loading: boolean; menu: StoreNavigationType[]}>({ loading: false, menu: [] })

export const useStoreNavigation = () => useContext(StoreNavigationContext)

interface StoreNavigationProviderProps {
    
}

const StoreNavigationProvider: React.FunctionComponent<StoreNavigationProviderProps> = ({children}) => {
    const request = useAuthAPI('/api/NavigationMenu/3', {
        method: 'GET'
    })

    useLayoutEffect(() => {
        request.call()
    }, [])

    const menu = request.response?.menu || []
    
    return (
        <StoreNavigationContext.Provider value={{loading: request.loading, menu}}>
            {children}
        </StoreNavigationContext.Provider>
    )
}

export default StoreNavigationProvider
